import React, {Component} from 'react';

import {BusinessUnitTabs} from "./BusinessUnitTabs";
import {BusinessUnitHeader} from "./BusinessUnitHeader";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';
import { SimpleLineChart } from '../charts/SimpleLineChart';
import {SectionIntro} from "../elements/SectionIntro";

const MONTHS_ES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

class BusinessUnitBudgetHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            budgets: []
        }
    }

    componentDidMount() {
        this.getBudgetHistory();
    }

    getBudgetHistoryUrl() {
        return `${API_URL}business-unit/${this.props.match.params.id}/budget-history`
    }

    getBudgetHistory() {
        new APIClient(this.getBudgetHistoryUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    'budgets': response.data,
                });
            }
        })
    }

    formatDateShort(dateStr) {
        const parts = dateStr.split('/');
        if (parts.length !== 3) return dateStr;
        const monthIndex = parseInt(parts[1], 10) - 1;
        const yearShort = parts[2].slice(-2);
        const { i18n } = this.props;
        const months = i18n.language === 'es' ? MONTHS_ES : MONTHS_EN;
        return `${months[monthIndex]}/${yearShort}`;
    }

    formatMoney(value) {
        if (value == null) return '-';
        return '$ ' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    getChartData() {
        const { t } = this.props;
        const budgets = this.state.budgets;
        if (budgets.length === 0) return [];

        const reversed = [...budgets].reverse();
        const sliced = reversed.slice(-24);

        return sliced.map(budget => ({
            [t('business_unit_budget_history.year_month')]: this.formatDateShort(budget.from_date),
            [t('business_unit_budget_history.total_budget')]: budget.total_budget_raw,
            [t('business_unit_budget_history.cost')]: budget.cost_raw,
        }));
    }

    renderChart() {
        const { t } = this.props;
        const chartData = this.getChartData();
        if (chartData.length === 0) return null;

        const dimensionKey = t('business_unit_budget_history.year_month');
        const metricKeys = [
            t('business_unit_budget_history.total_budget'),
            t('business_unit_budget_history.cost'),
        ];

        return (
            <div style={{ margin: '0 -20px 10px' }}>
                <SimpleLineChart
                    data={chartData}
                    dimensionKey={dimensionKey}
                    metricKeys={metricKeys}
                    height={300}
                    tooltipFormatter={(value) => this.formatMoney(value)}
                />
            </div>
        );
    }

    renderPastBudgets() {
        const { t } = this.props;
        return this.state.budgets.map((budget) => {
            return (
                <tr key={budget.id}>
                    <td>
                        {this.formatDateShort(budget.from_date)}
                        {budget.is_current_period && (
                            <span className="badge-current-period">{t('business_unit_budget_history.current_period')}</span>
                        )}
                    </td>
                    <td>{budget.allocated_amount}</td>
                    <td>{budget.budget_currency}</td>
                    <td>{budget.leftover}</td>
                    <td>{budget.total_budget}</td>
                    <td>{budget.cost}</td>
                    <td>{budget.balance}<div className={`item -${budget.balance_level}`}>{budget.balance_percentage}</div></td>
                </tr>
            );
        });

    }
    render() {
        const { t } = this.props;
        return (
            <section className="section-content business-unit-workspace-page business-unit-budget-history-page">
                <BusinessUnitHeader businessUnitId={this.props.match.params.id}/>
                <BusinessUnitTabs
                    businessUnitId={this.props.match.params.id}
                    activeTab="-third"
                />
                <div className="section-body business-unit-workspace-body">
                    <SectionIntro
                        kicker={t('business_unit_sections.budget_history.kicker')}
                        title={t('business_unit_sections.budget_history.title')}
                        description={t('business_unit_sections.budget_history.description')}
                    />
                    <div className="section-body-item -wider box business-unit-workspace-card">
                        <header className="box-header">
                            <h2 className="box-title">{t('business_unit_budget_history.title')}</h2>
                        </header>
                        {this.renderChart()}
                        <div className="table-box budget-history">
                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th>{t('business_unit_budget_history.year_month')}</th>
                                    <th>{t('business_unit_budget_history.fixed_budget')}</th>
                                    <th>{t('business_unit_budget_history.currency')}</th>
                                    <th>{t('business_unit_budget_history.previous_month_diff')}</th>
                                    <th>{t('business_unit_budget_history.total_budget')}</th>
                                    <th>{t('business_unit_budget_history.cost')}</th>
                                    <th>{t('business_unit_budget_history.difference')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderPastBudgets()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default withRouterParams(withTranslation()(BusinessUnitBudgetHistory));
